import { useField } from 'formik';
import { InputBoxStyle } from '../../styles/common.style';
import { InputStyle, PasswordInputStyle } from './InputBox.style';

const InputBox = (props: any) => {
  const [field] = useField(props);
  const {
    showPasswordToggle,
    type,
    label,
    error,
    transparent,
    width,
    height,
    onChange,
    placeholder,
    ...rest
  } = props;

  const inputProps = {
    ...rest,
    className: props.className,
    name: field.name,
    color: props.color,
    value: props.value !== undefined ? props.value : field.value,
    onBlur: field.onBlur,
    onChange: onChange || field.onChange,
    placeholder: placeholder ?? label,
    width,
    height,
    transparent,
  };

  const usePasswordToggle = type === 'password' && showPasswordToggle;

  return (
    <InputBoxStyle>
      <label>{label}</label>
      {usePasswordToggle ? (
        <PasswordInputStyle {...inputProps} visibilityToggle />
      ) : (
        <InputStyle {...inputProps} type={type} />
      )}
      {error && <p className="error">{error}</p>}
    </InputBoxStyle>
  );
};

export default InputBox;
